import { configureStore } from '@reduxjs/toolkit';
import globalShared from './globalShared';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga';
import activityReducer from '../../../activity/Redux/activitySlice';

let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

export default configureStore({
  reducer: {
    globalShared: globalShared,
    activity: activityReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middleware)
});

sagaMiddleware.run(rootSaga);
